<template>
    <div id="feed">
        <div class="mcontainer full-width">
            <b-row>
                <b-col sm="12">
                    <!-- Hero Slider -->
                    <div v-if="sliderLoading" class="hero-slider-placeholder">
                        <b-spinner variant="light" />
                    </div>
                    <div v-else-if="slides.length > 0" class="hero-slider" style="margin-bottom: 40px;">
                        <div class="hero-slide" v-for="(slide, idx) in slides" :key="slide.id" v-show="currentSlide === idx">
                            <a v-if="slide.link_button" :href="slide.link_button" target="_blank" rel="noopener noreferrer">
                                <img :src="slide.background" :alt="slide.title" class="hero-slide-img">
                            </a>
                            <img v-else :src="slide.background" :alt="slide.title" class="hero-slide-img">
                        </div>
                        <button v-if="slides.length > 1" class="slider-nav slider-prev" @click="prevSlide" aria-label="Sebelumnya">
                            <Icon icon="mdi:chevron-left" width="24" height="24" />
                        </button>
                        <button v-if="slides.length > 1" class="slider-nav slider-next" @click="nextSlide" aria-label="Selanjutnya">
                            <Icon icon="mdi:chevron-right" width="24" height="24" />
                        </button>
                        <div v-if="slides.length > 1" class="slider-dots">
                            <span v-for="(_, idx) in slides" :key="idx" class="slider-dot" :class="{ active: currentSlide === idx }" @click="goToSlide(idx)"></span>
                        </div>
                    </div>
                    <div v-else>
                        <img src="@/assets/images/banner.png" alt="BANNER" style="margin-bottom: 40px;">
                    </div>
                </b-col>
                <b-col sm="12" lg="8">
                    <timeline-form @created="fetchFeedTimeline" />
                    <div>
                        <div v-if="data.length > 0">
                            <timeline-item v-for="item in data" :key="item.id" :data="item" />
                        </div>
                        <div v-else class="text-center py-20">
                            <empty>
                                <p class="pt-2">Timeline is empty</p>
                            </empty>
                        </div>

                        <div v-if="!timelines.isLastPage" class="load-more-loading text-center py-4 mt-3">
                            <b-spinner v-if="timelines.loadMoreLoading" />
                            <a href="" v-else @click.prevent="fetchFeedTimeline" class="card py-2 px-4 inline">Load More</a>
                        </div>
                    </div>
                </b-col>
                <b-col sm="12" lg="4" class="d-none d-lg-block">
                    <div class="flex justify-between relative md:mb-4 mb-3">
                        <h2 class="text-lg font-semibold"> Jelajahi Grup </h2>
                        <router-link to="/app/group" class="flex items-center justify-center h-9 lg:px-5 px-3 space-x-1.5 absolute right-0">
                        <span> Lihat Semua </span>
                        </router-link>
                    </div>
                    <div class="divide-y">
                        <ListFeedBlog v-for="group in groups" :key="group.id" :data="group" :styles="'feed'" :small="false" />
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import CardFeedVideo from '@/components/CardFeedVideo'
    import ListFeedBlog from '@/components/ListFeedBlog'
    import TimelineForm from '@/components/TimelineForm'
    import TimelineItem from '@/components/TimelineItem.vue'
    import Empty from '@/components/Empty.vue'
    import { Icon } from '@iconify/vue2'
    import axios from 'axios'
    import { mapState, mapActions } from 'vuex'

    export default {
        name: 'Feed',
        data () {
            return {
                resources: [],
                groups: [],
                slides: [],
                sliderLoading: true,
                currentSlide: 0,
                sliderTimer: null,
                timelines: {
                    currentPage: 0,
                    perPage: 5,
                    loadMoreLoading: false,
                    isLastPage: false
                }
            }
        },
        components: {
            CardFeedVideo,
            ListFeedBlog,
            TimelineForm,
            TimelineItem,
            Empty,
            Icon
        },
        computed: {
            ...mapState('timelines', ['data'])
        },
        created () {
            this.fetchData()
            this.fetchFeedTimeline()
            this.fetchSlides()
        },
        beforeDestroy () {
            this.stopSlider()
        },
        watch: {
            $route: 'fetchData'
        },
        methods: {
            ...mapActions('timelines', ['fetch']),
            fetchData () {
                const $this = this
                this.loading = false
                axios.get('group?limit=5').then(function (res) {
                    $this.groups = res.data.result
                    $this.loading = true
                })
                axios.get('resource?limit=5').then(function (res) {
                    $this.resources = res.data.result.data
                })
            },
            async fetchSlides () {
                this.sliderLoading = true
                try {
                    const res = await axios.get('cms/carousel')
                    this.slides = res.data.result || []
                    if (this.slides.length > 1) this.startSlider()
                } catch (e) {
                    this.slides = []
                } finally {
                    this.sliderLoading = false
                }
            },
            startSlider () {
                this.sliderTimer = setInterval(() => {
                    this.currentSlide = (this.currentSlide + 1) % this.slides.length
                }, 5000)
            },
            stopSlider () {
                if (this.sliderTimer) clearInterval(this.sliderTimer)
            },
            prevSlide () {
                this.stopSlider()
                this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length
                this.startSlider()
            },
            nextSlide () {
                this.stopSlider()
                this.currentSlide = (this.currentSlide + 1) % this.slides.length
                this.startSlider()
            },
            goToSlide (idx) {
                this.stopSlider()
                this.currentSlide = idx
                this.startSlider()
            },
            fetchFeedTimeline () {
                this.timelines.loadMoreLoading = true
                this.fetch({ limit: this.timelines.perPage, page: this.timelines.currentPage + 1, append: true })
                    .then(res => {
                        if (res.currentPage === res.lastPage) {
                            this.timelines.isLastPage = true
                        }
                        this.timelines.currentPage = res.currentPage
                    })
                    .finally(() => {
                        this.timelines.loadMoreLoading = false
                    })
            }
        }
    }
</script>

<style scoped>
.hero-slider {
    position: relative;
    width: 100%;
}

.hero-slide {
    width: 100%;
}

.hero-slide-img {
    width: 100%;
    height: auto;
    display: block;
}

.slider-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 36px; height: 36px;
    background: rgba(255,255,255,0.85);
    border: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    transition: background 0.15s;
    color: #1e293b;
    z-index: 2;
}
.slider-nav:hover { background: #fff; }
.slider-prev { left: 10px; }
.slider-next { right: 10px; }

.slider-dots {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 6px;
    z-index: 2;
}

.slider-dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    background: rgba(255,255,255,0.5);
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
}
.slider-dot.active {
    background: #fff;
    transform: scale(1.3);
}

.hero-slider-placeholder {
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    color: #94a3b8;
}
</style>
